@import "@zvuk-b2b/react-uikit/ui/styles/_variables";
@import "@zvuk-b2b/react-uikit/ui/styles/_mixins";

@import "src/application/layout/SmartLayout/_smart-layout-variables";

.SmartMenu {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    margin: 0;
    user-select: none;
    transition: width $transition-duration-m, padding $transition-duration-s, box-shadow $transition-duration-s;
    overflow: hidden auto;
    @include hide-scrollbar;

    &[data-expanded=true] {
        transition: width $transition-duration-m, padding $transition-duration-s, box-shadow $transition-duration-l;

        @include media-mobile {
            width: 100vw;
            padding: $ceil * 2;
        }

        @include media-desktop {
            width: $menu-desktop-width-expanded;
            padding: $ceil * 3;
            box-shadow: $shadow-xxl;
        }

        @include media-desktop-xs {
            padding: $ceil * 3 $ceil * 3 $ceil * 3 $ceil * 2;
        }

        @include media-desktop-s {
            padding: $ceil * 3 $ceil * 3 $ceil * 3 $ceil * 2;
        }
    }

    &[data-expanded=false] {
        transition: width $transition-duration-m, padding $transition-duration-s, box-shadow $transition-duration-s;

        @include media-mobile {
            width: 1px;
            padding: $ceil * 2 0;
        }

        @include media-desktop {
            width: $menu-desktop-width-collapsed;
            padding: $ceil * 3 0 $ceil * 3 $ceil * 3;
        }

        @include media-desktop-xs {
            padding: $ceil * 3 $ceil $ceil * 3 $ceil * 2;
        }

        @include media-desktop-s {
            padding: $ceil * 3 $ceil $ceil * 3 $ceil * 2;
        }
    }

    &Logo {
        margin-top: 4px;
        margin-left: $ceil + 2;
        margin-bottom: $ceil * 5;
    }

    &Top,
    &Bottom {
        display: grid;
        grid-auto-flow: row;
        gap: $ceil;
    }

    &Bottom {
        margin-top: auto;
    }
}
